
export enum RebelIqQueryStringKeys {
  email                 = 'email',
  fico                  = 'fico',
  firstName             = 'firstName',
  homeEquityLoanPurpose = 'homeEquityLoanPurpose',
  homeValue             = 'homeValue',
  lastName              = 'lastName',
  loanAmount            = 'loanAmount',
  mortgageBalance       = 'mortgageBalance',
  phone                 = 'phone',
  propertyCity          = 'propertyCity',
  propertyState         = 'propertyState',
  propertyStreet        = 'propertyStreet',
  propertyType          = 'propertyType',
  propertyUsage         = 'propertyUsage',
  propertyZip           = 'propertyZip',
}

export enum RebelIqPropertyType {
  SINGLE_FAMILY = 'SFH',
  CONDOMINIUM   = 'CON',
  MULTI_FAMILY  = '24U',
}

export enum RebelIqPropertyUsage {
  PRIMARY    = 'PRI',
  SECONDARY  = '2ND',
  INVESTMENT = 'INV',
}

export enum RebelIqFico {
  FICO_700 = '700',
  FICO_699 = '699',
  FICO_659 = '659',
}

export enum RebelIqHomeEquityLoanPurpose {
  BRIDGE_LOAN                = 'Bridge Loan',
  BUSINESS_USE               = 'Business Use',
  COMPLETED_HOME_IMPROVEMENT = 'Completed Home Improvement',
  DEBT_CONSOLIDATION         = 'Debt Consolidation',
  FUTURE_HOME_IMPROVEMENT    = 'Future Home Improvement',
  OTHER                      = 'Other',
  PURCHASE_ANOTHER_HOME      = 'Purchase Another Home',
}